import React, { useState } from "react";
import Footer from "../component/Footer";
import "../Text Modification Formatting/text.css";

const BoldTextGenerator = () => {
  const [textareaValue, setTextareaValue] = useState("");
  const [boldText, setBoldText] = useState("");
  const [textStatistics, setTextStatistics] = useState({
    wordCount: 0,
    letterCount: 0,
    sentenceCount: 0,
    lineCount: 0,
  });

  const handleChange = (event) => {
    const text = event.target.value;
    setTextareaValue(text);
    setBoldText(convertToBold(text));
    setTextStatistics(calculateTextStatistics(text));
  };

  const convertToBold = (text) => {
    const boldMap = {
      a: "𝗮", b: "𝗯", c: "𝗰", d: "𝗱", e: "𝗲", f: "𝗳", g: "𝗴",
      h: "𝗵", i: "𝗶", j: "𝗷", k: "𝗸", l: "𝗹", m: "𝗺", n: "𝗻",
      o: "𝗼", p: "𝗽", q: "𝗾", r: "𝗿", s: "𝘀", t: "𝘁", u: "𝘂",
      v: "𝘃", w: "𝘄", x: "𝘅", y: "𝘆", z: "𝘇",
      A: "𝗔", B: "𝗕", C: "𝗖", D: "𝗗", E: "𝗘", F: "𝗙", G: "𝗚",
      H: "𝗛", I: "𝗜", J: "𝗝", K: "𝗞", L: "𝗟", M: "𝗠", N: "𝗡",
      O: "𝗢", P: "𝗣", Q: "𝗤", R: "𝗥", S: "𝗦", T: "𝗧", U: "𝗨",
      V: "𝗩", W: "𝗪", X: "𝗫", Y: "𝗬", Z: "𝗭",
      0: "𝟬", 1: "𝟭", 2: "𝟮", 3: "𝟯", 4: "𝟰", 5: "𝟱", 6: "𝟲",
      7: "𝟳", 8: "𝟴", 9: "𝟵"
    };

    return text.split('').map(char => boldMap[char] || char).join('');
  };

  const calculateTextStatistics = (text) => {
    const words = text
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0);
    const letters = text.replace(/\s+/g, "").length;
    const sentences = text
      .split(/[.!?]+/)
      .filter((sentence) => sentence.trim().length > 0);
    const lines = text.split("\n");

    return {
      wordCount: words.length,
      letterCount: letters,
      sentenceCount: sentences.length,
      lineCount: lines.length,
    };
  };

  const handleDownload = () => {
    const blob = new Blob([boldText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'bold-text.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleClear = () => {
    setTextareaValue("");
    setBoldText("");
    setTextStatistics({
      wordCount: 0,
      letterCount: 0,
      sentenceCount: 0,
      lineCount: 0,
    });
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(boldText);
  };

  return (
    <div className="container">
      <main>
        <h1>Rabbit Case</h1>
        <div className="content">
          <h2>Bold Text Generator</h2>
          <p>
            Use this handy bold text generator. Simply paste or write the text
            that you need to be converted into a bold font into the left field,
            then as you write it, you will see it being converted into bold into
            the field on the right. Then simply copy it from the bold text
            converter and paste it where you want it to go.
          </p>
          <div className="textarea-container">
            <textarea
              value={textareaValue}
              onChange={handleChange}
              placeholder="Start typing your notes here..."
              rows="8"
              className="textarea-animated"
            />
            
            <textarea
              value={boldText}
              placeholder="Converted text will appear here..."
              rows="8"
             className="textarea-animated"
              readOnly
            />
            
          </div>
          
          <div className="stats-text">
            Words: {textStatistics.wordCount} | Letters: {textStatistics.letterCount} | Sentences: {textStatistics.sentenceCount} | Lines: {textStatistics.lineCount}
          </div>

          <div  className="btn1-container">
            <button class="btn-421" onClick={handleDownload}>Download Text</button>
            <button class="btn-421" onClick={handleCopy}>Copy to Clipboard</button>
            <button class="btn-421" onClick={handleClear}>Clear</button>
          </div>
          <br />
        </div>
        <br />
        <div className="content1">
          <h3>Bold Font Text Converter</h3>
          <p>
            When you need to quickly make text stand out, few options look more
            imposing than bold text. However, editing all of your own text into
            bold type can be a time consuming exercise. Unless you are extremely
            fluent with things like keyboard shortcuts, you might be quicker
            using our bold text converter. Such a quick and easy solution can
            quickly turn around your bold text needs, ensuring you are left with
            content that stands out for all of the right reasons and styles.
          </p>
          <p>
            Today, bold text is such a commonly used solution to help draw the
            attention of the audience to something in particular. It can be a
            great stylistic choice, too, for making something stand out. For
            example, a key stat or fact you wish to portray might be easier
            understood if you can spend some time focusing on the bold text.
            Bold type is a big stylistic change that can really quickly make a
            big impression, ensuring that you are left with a new kind of text
            that draws attention and gets people interested in what you have to
            say.
          </p>
          <p>
            It’s the little things in life that can really make a big
            impression, and this is the case when it comes to our bold text
            converter. These tools can quickly and easily turn around a job
            that, managed manually, could be a huge undertaking and physical
            effort.
          </p>
          <p>
            If you are trying to cut down on the time that you spend involved in
            any job in particular, this is a good way to do so. Editors like
            this allow for you to quickly copy or write in as much text as you
            need into the left-hand side box. Then, you simply have to take the
            text on the right-hand side box. You can copy it using the ‘Copy to
            Clipboard’ content or using the ‘Download Text’ component.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>How Does the Bold Case Converter Work?</h3>
          <p>
            To use it and get your bold text generated, all you need to do is
            simply write up the content as you would normally in the left
            column. Then as you do so, you will notice that on the right hand
            column that the text is starting to get transformed into the bolded
            version.
          </p>
          <p>
            Once you have finished writing out the text that you want to get
            bolded. You will see that all the text you want in bold is available
            to you for copying and pasting wherever you’d like. Simply highlight
            the text on the right, ‘copy’ it and then click paste into your
            desired text editor.
          </p>
          <p>
            If you are looking for an example of bolded text then please see
            below:
          </p>
          <p>𝗧𝗵𝗶𝘀 𝗶𝘀 𝗮𝗻 𝗲𝘅𝗮𝗺𝗽𝗹𝗲 𝗼𝗳 𝗯𝗼𝗹𝗱 𝘁𝗲𝘅𝘁.</p>
          <p>
            Let us know also if you have any potential ideas on how we can
            improve the bold text generator further? Simply contact us via the
            contact page, we can’t wait to hear what you’re thinking.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BoldTextGenerator;
